import React from "react";
import LCLogo from "../../../assets/laguna-creek-logo.png";
import { Link } from "react-router-dom";

function OurLocationSection({ our_location }) {
  const defaultLOGO = LCLogo;
  const defaultSubTitle = "Our Location";
  const defaultTitle = "Headquarters";
  const defaultBusinessname = "Laguna Creek, LLC";
  const defaultAddress = "971 N Gilbert Rd STE #315 <br>Gilbert, AZ 85234";
  const defaultAddressURL = "https://maps.app.goo.gl/DZMtp69whVx6dbgF6";
  const defaultPhoneNo = "(623) 300-2434";

  const logo = our_location?.logo || defaultLOGO;
  const subtitle = our_location?.sub_title || defaultSubTitle;
  const title = our_location?.title || defaultTitle;
  const businessname = our_location?.business_name || defaultBusinessname;
  const address = our_location?.address || defaultAddress;
  const addressurl = our_location?.address_url || defaultAddressURL;
  const phoneno = our_location?.phone_no || defaultPhoneNo;

  const lines = address.split(/<br\s*\/?>/i);

  return (
    <>
      <section className="py-12 lg:py-24 border-t border-[#E7E7E7]">
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap items-center -mx-4">
            <div className="w-full md:w-1/2 xl:w-3/5 max-w-full px-4">
              <div className="text-center">
                <img
                  src={logo}
                  alt="OurStory"
                  className="max-w-[200px] sm:max-w-[300px] md:max-w-full mx-auto mb-8 md:mb-0"
                  height="548"
                  width="547"
                />
              </div>
            </div>
            <div className="w-full md:w-1/2 xl:w-2/5 max-w-full px-4">
              <div className="text-center md:text-left md:max-w-[354px] md:mr-0 md:ml-auto xl:ml-0 xl:mr-auto">
                <p className="text-xl md:text-2xl font-semibold leading-snug text-[#192020] mb-2">
                  {subtitle}
                </p>
                <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-snug text-[#192020] mb-2 relative after:content-[''] after:absolute after:-left-[45px] after:top-1/2 after:bg-[#FAA42A] after:w-[14px] after:h-[14px] after:rounded-full after:-translate-y-1/2 before:content-[''] before:absolute before:right-[calc(100%+45px)] before:top-1/2 before:bg-[#DFDFDF] before:w-[200px] before:h-[1px] before:-translate-y-1/2  before:-z-10">
                  {title}
                </h2>
                <p className="text-lg font-semibold leading-[30px] text-[#192020] mb-0.5">
                  {businessname}
                </p>
                <Link to={addressurl} target="_blank" className="group">
                  {lines.map((line, index) => (
                    <span
                      key={index}
                      className="block text-lg font-light leading-[30px] text-[#192020] group-hover:text-[#5FA3B2] transition-all ease-in-out duration-500"
                    >
                      {line.trim()}
                    </span>
                  ))}
                </Link>
                <Link
                  to={`tel:+1${phoneno.replace(/\D/g, "")}`}
                  className="group"
                >
                  <span className="block text-lg font-light leading-[30px] text-[#192020] group-hover:text-[#5FA3B2] transition-all ease-in-out duration-500">
                    {phoneno}
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OurLocationSection;
